module.exports = __webpack_public_path__ + "img/code4_border.4e6fd65e.jpg";